import { render, staticRenderFns } from "./VendorAppFee.vue?vue&type=template&id=522e735a"
import script from "./VendorAppFee.vue?vue&type=script&lang=js"
export * from "./VendorAppFee.vue?vue&type=script&lang=js"
import style0 from "./VendorAppFee.vue?vue&type=style&index=0&id=522e735a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports